import { createAction } from 'redux-actions'

export const setStoreDetailsInformation = createAction('STORE_DETAILS_INFORMATION/SET_STORE_DETAILS_INFORMATION')
